import state from './OperatorState';
import actions from './OperatorActions';
import mutations from './OperatorMutations';

// Namespaced Vuex module which contains its
// own state, actions, getters, mutations.
export default {
  state,
  actions,
  mutations,
  namespaced: true
};
